meedy.factory('meedy.integrationsModel', ['$rootScope', '$q', 'applicationModel', 'meedy.baseModel', 'meedy.integrationsService',
    function($rootScope, $q, applicationModel, baseModel, integrationsService) {

        function IntegrationsModel() {

            this.getAlabExaminationResultFileLink = function(term, file) {
                return integrationsService.getAlabExaminationResultFileLink(term, file).then(
                    function (data) {
                        return data;
                    },
                    function(error) {
                        $q.reject(error);
                    }
                )
            };

            this.downloadExaminationFileAndOpenNewTab = function(fileUrl) {
                return integrationsService.downloadExaminationFileAndOpenNewTab(fileUrl).then(
                    function (data) {
                        return data;
                    },
                    function(error) {
                        $q.reject(error);
                    }
                )
            };


            this.getP1EReferralPreview = function(body) {
                return integrationsService.getP1EReferralPreview(body).then(
                    function (html) {
                        return html;
                    },
                    function(error) {
                        $q.reject(error);
                    }
                )
            };
        }

        return new IntegrationsModel();
    }
]);
